<template>
    <v-expansion-panel-header class="header-list__text">
        <slot></slot>
        <template v-slot:actions>
            <v-icon color="primary">
                mdi-menu-down
            </v-icon>
        </template>
    </v-expansion-panel-header>
</template>

<script>
  export default {
    name: 'ExpansionPanelHeader',
    data () {
      return {
      }
    }

  }
</script>

<style scoped lang="scss">
.header-list__text {
  font-size: 14px;
  color: var(--primary);
  font-weight: bolder;
}
</style>
